import { Box } from "@mui/material";
import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";

import {
  DELIVERABILITY_DIMENSIONS_DASHBOARD_ID,
  DELIVERABILITY_DIMENSIONS_FILTER_ID,
} from "@/api/dimensions/constants";
import { LoadingFallback } from "@/components/LoadingFallback";
import { DimensionsOmniIframe } from "@/features/Dimensions/DimensionsOmniIframe";
import { isDimensionsDeliverabilityEnabledForSite } from "@/features/Dimensions/flag";
import {
  hasElevatedAccessValue,
  useHasElevatedAccess,
  usePrivilegedModeStore,
} from "@/utils/privilegedMode";

export const Route = createFileRoute("/_auth/dimensions/$siteId/deliverability")({
  beforeLoad: ({ context, params }) => {
    if (
      !hasElevatedAccessValue(
        context.auth?.user?.user.role,
        usePrivilegedModeStore.getState().disabled,
      ) ||
      !isDimensionsDeliverabilityEnabledForSite(params.siteId)
    ) {
      throw redirect({ to: "/dimensions/$siteId", params });
    }
  },
  component: RouteComponent,
  pendingComponent: LoadingFallback,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const hasElevatedAccess = useHasElevatedAccess();

  // Unmount the embed immediately if staff access changes after navigation.
  if (
    !hasElevatedAccess ||
    !isDimensionsDeliverabilityEnabledForSite(siteId)
  ) {
    return <Navigate to="/dimensions/$siteId" params={{ siteId }} replace />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <DimensionsOmniIframe
        siteId={siteId}
        dashboardId={DELIVERABILITY_DIMENSIONS_DASHBOARD_ID}
        filterId={DELIVERABILITY_DIMENSIONS_FILTER_ID}
        title="Dimensions — Deliverability"
      />
    </Box>
  );
}
